export default "__VITE_ASSET__CzyEpPld__"